import { Util } from '../utils/util';

export class ValidationDOMHelper {
    private static addDescribedBy(input: HTMLElement, id: string) {
        if (!id) return;
        const existing = (input.getAttribute("aria-describedby") || "")
            .split(/\s+/)
            .filter(Boolean);

        if (!existing.includes(id)) {
            existing.push(id);
            input.setAttribute("aria-describedby", existing.join(" "));
        }
    }

    private static removeDescribedBy(input: HTMLElement, id: string) {
        if (!id) return;
        const existing = (input.getAttribute("aria-describedby") || "")
            .split(/\s+/)
            .filter(Boolean);

        const next = existing.filter(x => x !== id);
        if (next.length) input.setAttribute("aria-describedby", next.join(" "));
        else input.removeAttribute("aria-describedby");
    }

    public static applyErrorState(input: HTMLInputElement, errorSpanId: string, extraIds?: string[]) {
        if (input.type === "checkbox") {
            const label = document.querySelector(`label[for="${input.id}"]`);
            label?.classList.add("invalid-checkbox");
        } else {
            input.classList.add("invalid-input");
            extraIds?.forEach(id => document.getElementById(id)?.classList.add("invalid-input"));
        }

        input.setAttribute("aria-invalid", "true");
        this.addDescribedBy(input, errorSpanId);

        const errEl = document.getElementById(errorSpanId) as HTMLElement | null;
        const wasHidden =
            !!errEl &&
            (errEl.classList.contains("hidden") || errEl.getAttribute("aria-hidden") === "true");

        // Make it visible
        Util.showElement(errorSpanId);

        // Announce only when it becomes visible (prevents repeat spam)
        if (!Util.isBatchAnnouncementActive && errEl && wasHidden) {
            const msg = (errEl.textContent || "").trim();
            if (msg) Util.announce(msg);
        }
    }

    public static clearErrorState(input: HTMLInputElement, errorSpanId: string, extraIds?: string[]) {
        if (input.type === "checkbox") {
            const label = document.querySelector(`label[for="${input.id}"]`);
            label?.classList.remove("invalid-checkbox");
        } else {
            input.classList.remove("invalid-input");
            extraIds?.forEach(id => document.getElementById(id)?.classList.remove("invalid-input"));
        }

        input.removeAttribute("aria-invalid");
        this.removeDescribedBy(input, errorSpanId);

        // Hide message
        Util.hideElement(errorSpanId);
    }
}